module.exports = __webpack_public_path__ + "static/media/about_black_ginssen_icon2.5c2f1b68.png";